<template>
  <div class="sn-new-ranking">
    <div class="slot" :class="{'slot-all': optionTab==='all', 'slot-positive': optionTab==='positive', 'slot-negative': optionTab==='negative'}">
      <slot></slot>
    </div>
    <div class="content">
      <div @click="onBarClick(item.name)" class="bar-container" v-for="(item, index) in newData" :key="index">
        <div class="name">{{item.name}}</div>
        <div class="num">{{item.num}}</div>
        <div class="row bar" :class="{'all': optionTab==='all', 'positive': optionTab==='positive', 'negative': optionTab==='negative'}">
          <div v-show="item.num" class="rectangle"  :style="{width: `${item.width-5}%`}"></div>
          <div v-show="item.num" class="triangle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    optionTab: {
      type: String
    }
  },
  methods: {
    onBarClick(name) {
      this.$emit('onBarClick', name);
    }
  },
  computed: {
    newData() {
      if (this.data.length > 0) {
        const dataMap = this.data.map((item) => {
          return {
            name: item.name,
            num: item.num
          };
        });
        const dataSort = dataMap.sort((a, b) => {
          return b.num > a.num ? 1 : -1;
        });
        const ratio = dataSort[0].num;
        const data1 = dataSort.map(item => {
          return {
            name: item.name,
            num: item.num,
            width: item.num / ratio * 100
          };
        });
        return data1;
      }
      return [];
    }
  }
};
</script>

<style lang="scss" scoped>
  .sn-new-ranking {
    height: 232px;
    padding: 24px 0 22px;
    background-color: #3e3c42;
    .slot {
      padding-left: 24px;
      padding-bottom: 16px;
      font-size: 14px;
    }
    .slot-all {
      color: #40e4ff;
    }
    .slot-positive {
      color: #ff5b65;
    }
    .slot-negative {
      color: #6eecb9;
    }
    .content {
      .bar-container {
        position: relative;
        padding-bottom: 4px;
        cursor: pointer;
        .name {
          position: absolute;
          left: 24px;
          color: #ffffff;
          font-size: 14px;
          z-index: 1;
        }
        .num {
          position: absolute;
          right: 24px;
          color: #ffffff;
          font-size: 14px;
          z-index: 1;
        }
        .bar {
          height: 21px;
          .rectangle {
            opacity: 0.55;
          }
          .triangle {
            width: 0px;
            height: 0px;
            border-left:5px solid transparent;
            border-top:10.5px solid transparent;
            border-bottom:10.5px solid transparent;
            border-right:5px solid transparent;
            opacity: 0.55;
          }

          &:hover {
            background-color: #29272e;
          }
        }

        .all {
          .rectangle {
            background-color: #4fa3c8;
            opacity: 0.55;
          }
          .triangle {
            border-top-color: #4fa3c8;
            border-left-color: #4fa3c8;
            opacity: 0.55;
          }

          &:hover {
            .rectangle {
              opacity: 0.9;
            }
            .triangle {
              opacity: 0.9;
            }
          }
        }


        .positive {
          .rectangle {
            background-image: linear-gradient(90deg,  #ff7780 0%, #ef4e6b 100%);
          }
          .triangle {
            border-top-color: #ef4e6b;
            border-left-color: #ef4e6b;
          }

          &:hover {
            .rectangle {
              opacity: 0.9;
            }
            .triangle {
              opacity: 0.9;
            }
          }
        }

        .negative {
          .rectangle {
            background-image: linear-gradient(90deg, #54cec2 0%, #54cea4 100%);
          }
          .triangle {
            border-top-color: #54cea4;
            border-left-color: #54cea4;
          }

          &:hover {
            .rectangle {
              opacity: 0.9;
            }
            .triangle {
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
</style>

